module.exports = __webpack_public_path__ + "static/media/fries.601e45dc.jpg";